import $ from './plugins/jquery-global';
import './plugins/select2-i18n';

window.FWSchoolDropdown = window.FWSchoolDropdown || {};

(function (config) {
    const $form = $('#select-institution');
    const $institutionsSectionDropdown = $('.institutions--section-dropdown');
    const $institutionDropdown = $('#institutionDropdown');
    const $institutionDropdownDefaultOption = $('#institutionDropdown > option:first-child').clone()[0];

    const $countryDropdown = $('#countryDropdown');

    // Unicode combining diacritical marks (U+0300–U+036F). Built via RegExp from an
    // ASCII-only string so the source stays byte-stable through formatters.
    const combiningMarks = new RegExp('[\\u0300-\\u036f]', 'g');

    const normalizeString = function (str) {
        return str.normalize('NFD').toLowerCase().replace(combiningMarks, '');
    };

    const getWordBoundaryScore = function (term, name) {
        const normalizedTerm = normalizeString(term);
        const normalizedName = normalizeString(name);

        if (normalizedName === normalizedTerm) {
            return 4;
        }

        if (normalizedName.startsWith(normalizedTerm)) {
            return 3;
        }

        const words = normalizedName.split(/[\s\-(),./]+/);
        const hasWordStartingWithTerm = words.some((word) => word.startsWith(normalizedTerm));

        if (hasWordStartingWithTerm) {
            return words[0].startsWith(normalizedTerm) ? 2 : 1;
        }

        const index = normalizedName.indexOf(normalizedTerm);
        if (index > 0) {
            const charBefore = normalizedName[index - 1];
            if (!/[a-z0-9]/i.test(charBefore)) {
                return 0;
            }
        }

        return -1;
    };

    const initInstitutionDropdown = function (data = [], disabled = true) {
        if ($institutionDropdown.hasClass('select2-hidden-accessible')) {
            $institutionDropdown.select2('destroy');
            $institutionDropdown.empty();
            $institutionDropdown.append($institutionDropdownDefaultOption);
        }

        $institutionDropdown.removeClass('js-hidden');

        if (disabled === false) {
            $institutionsSectionDropdown.removeAttr('disabled');
        }

        $institutionDropdown.select2({
            width: 'resolve',
            minimumInputLength: data.length >= 30 ? 3 : 0,
            disabled: disabled,
            data: data,
            matcher: function (params, data) {
                if (!params.term) {
                    return data;
                }

                const score = getWordBoundaryScore(params.term, data.text);
                if (score < 0) {
                    return null;
                }

                data._score = score;
                return data;
            },
            sorter: function (data) {
                return data.sort((a, b) => {
                    const scoreB = b._score !== undefined ? b._score : 0;
                    const scoreA = a._score !== undefined ? a._score : 0;

                    if (scoreB !== scoreA) {
                        return scoreB - scoreA;
                    }

                    return a.text.localeCompare(b.text);
                });
            },
        });
    };

    const fetchInstitutions = function (countryCode) {
        const endpoint = $institutionDropdown.data('endpoint') + '/' + countryCode;

        $institutionsSectionDropdown.attr('disabled', 'disabled');

        $institutionsSectionDropdown.removeClass('closed');

        $.getJSON(endpoint, function (data) {
            const options = data.map(function (item) {
                return {
                    id: item.url,
                    text: item.name,
                };
            });

            initInstitutionDropdown(options, false);
        });
    };

    const initCountryDropdown = function () {
        const formatCountry = function (country) {
            if (!country.id) {
                return country.text;
            }

            const countryIcon = `https://hatscripts.github.io/circle-flags/flags/${country.id.toLowerCase()}.svg`;

            const $country = $(
                '<span class="country-option"><img src="' + countryIcon + '" /><span>' + country.text + '</span></span>'
            );
            return $country;
        };

        $countryDropdown.removeClass('js-hidden');
        $countryDropdown.select2();

        $.getJSON($countryDropdown.data('endpoint'), function (data) {
            $countryDropdown.select2({
                templateResult: formatCountry,
                templateSelection: formatCountry,
                data: data.results,
            });

            $countryDropdown.on('select2:open', () => {
                document.querySelector('.select2-search__field').focus();
            });

            $countryDropdown.on('select2:select', (e) => {
                const countryCode = e.params.data.id;
                fetchInstitutions(countryCode);
            });

            $countryDropdown.trigger('change');
            $('.institutions__select--country').removeAttr('disabled');
        });
    };

    $(function () {
        // add [disabled] attribute to institution dropdown

        switch (config) {
            case 'hidden':
                $institutionsSectionDropdown.addClass('institutions--section-dropdown--hidden');
                break;

            default:
                $institutionsSectionDropdown.addClass('institutions--section-dropdown--disabled');
                break;
        }

        $form.removeClass('js-hidden');
        $institutionsSectionDropdown.removeClass('js-hidden');
        initCountryDropdown();
        initInstitutionDropdown();

        // Update select2 width on screen resize.
        $(window).on('resize', function () {
            $('.institutions__select').each(function () {
                const fieldWidth = $(this).outerWidth();
                $(this).find('.select2-container').css('width', fieldWidth);
            });
        });

        $form.on('submit', function (e) {
            e.preventDefault();

            let messageBlock = $(this).find('div.messaging');

            if (!messageBlock.hasClass('js-hidden')) {
                messageBlock.addClass('js-hidden');
            }

            var url = $(this).find('select[name="institution"]').children('option:selected').val();

            if (url.length == 0) {
                $(this).find('div.messaging').removeClass('js-hidden');
                return false;
            }

            document.location.assign(url);
        });
    });
})(window.FWSchoolDropdown);

// Enable HMR for Vite
if (import.meta.hot) {
    import.meta.hot.accept();
}
